import { RowState } from "../models/enums";
import { Injectable, OnDestroy } from "@angular/core";
import { MisSetUp } from "../models";
import { ActivatedRoute } from "@angular/router";
import { BehaviorSubject, Observable, Subject, throwError } from "rxjs";
import { catchError, takeUntil } from "rxjs/operators";
import { HttpCommonService } from "./http-common.service";
import { ShowToastrService } from "./show-toastr.service";
import { LocalStoreManager } from "./local-store-manager.service";
import { InvVoucherHeader } from "src/app/backoffice/inv/models/inv-voucher-header.model";

@Injectable({
  providedIn: "root",
})
export class MisSetupService implements OnDestroy {
  ngUnsubscribe = new Subject<void>();
  apiName: string = "MisSetUp";
  public source: MisSetUp[];
  public isLoding: boolean = false;
  model = <MisSetUp>{};
  public isSaving: boolean;
  public isNewRow = false;
  label = "تنظیمات سیستم";
  public source$: BehaviorSubject<MisSetUp[]>;

  public changesSavedCallback: () => void;
  public changesFailedCallback: () => void;
  public changesCancelledCallback: () => void;

  constructor(
    protected httpCommonService: HttpCommonService,
    private sts: ShowToastrService,
    protected route: ActivatedRoute,
    protected localStorage: LocalStoreManager
  ) {
    this.getall();
    this.source$ = new BehaviorSubject<MisSetUp[]>([]);
  }
  ngOnDestroy(): void {
    if (this.ngUnsubscribe) {
      this.ngUnsubscribe.next();
      this.ngUnsubscribe.complete();
    }
    this.source = undefined;
  }
  getall() {
    if (this.isLoding) return;
    this.isLoding = true;
    this.httpCommonService
      .getList(this.apiName + "/ReadMisSetUpLookUp")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data) => {
          this.isLoding = false;
          if (data !== undefined) this.source = data as any[];
          this.source$.next(this.source);
          this.setTimeOut();
        },
        (error) => {
          this.isLoding = false;
        }
      );
  }
  setTimeOut() {
    let val = this.getValue("GNR", "ToasterTimeOut");
    if (!val) this.localStorage.deleteData("ToasterTimeOut");
    else this.localStorage.saveSessionData(JSON.parse(val) * 1000, "ToasterTimeOut");
  }
  async save() {
    if (!this.source && !this.source.filter((x) => x.State === RowState.Modify || x.State === RowState.New)) return;
    let list = this.source.filter((x) => x.State === RowState.Modify || x.State === RowState.New);
    this.sts.showToast("info", "", "در حال ذخیره تغییرات...");
    let newList: any[] = [];
    let editList: any[] = [];
    let deleteList: any[] = [];
    for (var i = 0; i < list.length; i++) {
      let x = list[i];
      if (x.State === RowState.New && !newList.some((l) => l.KeyValue === x.KeyValue && l.SystemName === x.SystemName)) {
        newList.push(x);
        this.isSaving = true;
      }
      if (x.State === RowState.Modify) {
        editList.push(x);
        this.isSaving = true;
      }
      let find = this.source.find((f) => f.KeyValue === x.KeyValue && f.SystemName === x.SystemName && f.Id !== x.Id);

      if (find) {
        deleteList.push(find);
        this.isSaving = true;
      }
    }

    let isOk: boolean = false;
    if (newList.length > 0) {
      this.httpCommonService
        .bulkInsert(this.apiName, newList)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (row) => {
            this.saveSuccessHelper(row);
            if (editList.length <= 0) this.getall();
          },
          (error) => this.saveFailedHelper(error)
        );
    }
    if (editList.length > 0) {
      this.httpCommonService
        .bulkUpdate(this.apiName, editList)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (row) => {
            this.saveSuccessHelper(row);
            this.getall();
          },
          (error) => this.saveFailedHelper(error)
        );
    }
    if (deleteList.length > 0) {
      this.httpCommonService
        .bulkDelete(this.apiName, deleteList)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (row) => {
            this.saveSuccessHelper(row);
            this.getall();
          },
          (error) => this.saveFailedHelper(error)
        );
    }
    this.sts.showToast("success", "موفقیت آمیز", `تغییرات اطلاعات  ${this.label}  با موفقیت ذخیره شد `);
  }
  private saveSuccessHelper(row?: any) {
    if (row) Object.assign(this.model, row);
    this.isSaving = false;
    if (this.changesSavedCallback) this.changesSavedCallback();
  }

  private saveFailedHelper(error: any) {
    this.isSaving = false;
    this.sts.showToast("danger", "", error);
    this.sts.showDialog(`خطای ذخیره تغییرات: ${error}`, "پیغام خطا");
    if (this.changesFailedCallback) this.changesFailedCallback();
  }
  public getValue(SystemName: string, KeyValue: string): any {
    if (this.source === undefined) this.getall();
    if (this.source === undefined || this.source.length === 0) return undefined;
    let items = this.source.filter((x) => x.SystemName === SystemName && x.KeyValue === KeyValue);
    if (items === undefined || items.length === 0) {
      let rules = this.source.filter((x) => x.SystemName === SystemName && x.KeyValue === KeyValue);
      if (rules === undefined || rules.length === 0 || !rules[0].DataValue) return null;
      else if (rules[0] && rules[0].DataValue) return String(rules[0].DataValue).trim();
    } else {
      if (items[0] && items[0].DataValue) return String(items[0].DataValue).trim();
    }
    return undefined;
  }
  getnumber(SystemName: string, KeyValue: string): number {
    let result: any = 0;
    let val = this.getValue(SystemName, KeyValue);
    if (!val) return result;
    return JSON.parse(val);
  }
  getboolean(SystemName: string, KeyValue: string): boolean {
    let result: any = undefined;
    let val = this.getValue(SystemName, KeyValue);
    if (!val) return result;
    return JSON.parse(val);
  }
  getstring(SystemName: string, KeyValue: string): string {
    let result: any = undefined;
    let val = this.getValue(SystemName, KeyValue);
    if (!val) return result;
    return JSON.parse(val);
  }
  hasAccVoucher(): Observable<boolean> {
    var abs = new BehaviorSubject<boolean>(false);
    this.httpCommonService
      .get<boolean>("AccVoucherHeader/HasAccVoucher")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((x) => {
        abs.next(x);
      });
    return abs.asObservable();
  }
  hasSubLedger(): Observable<boolean> {
    var abs = new BehaviorSubject<boolean>(false);
    this.httpCommonService
      .get<boolean>("SubLedger/HasSubLedegr")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((x) => {
        abs.next(x);
      });
    return abs.asObservable();
  }
  hasGeneralLedger(): Observable<boolean> {
    var abs = new BehaviorSubject<boolean>(false);
    this.httpCommonService
      .get<boolean>("GeneralLedger/HasGeneralLedegr")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((x) => {
        abs.next(x);
      });
    return abs.asObservable();
  }

  getAllInventorySave() {
    return this.httpCommonService.get<InvVoucherHeader[]>("MisSetUp/InventorySave").pipe(
      catchError((error) => {
        return throwError(error);
      })
    );
  }
}
